import { TRANSACTION_TYPE } from "../../domain/TransactionType";

export function mapToWastesDetails(wastesDetailsData, transactionType){
  const wasteExchanges = [];
  if (wastesDetailsData.isLoading && wastesDetailsData.loading?.wastes?.length > 0) {
    const loadExchangeItem = {
      isContainer: false,
      wastes: mapToRequestWastes(wastesDetailsData.loading.wastes),
      usedContainerId: null,
      wasteExchangeId: wastesDetailsData.loading.wasteExchangeId
    };

    wasteExchanges.push(loadExchangeItem);
  }

  if (wastesDetailsData.isContainerExchange && wastesDetailsData.containers?.length > 0) {
    const containerExchangeItems = wastesDetailsData.containers?.map((x, idx) => ({
      isContainer: true,
      wastes: mapToRequestWastes(x.wastes),
      usedContainerId: x.usedContainer?.usedContainerId,
      wasteExchangeId: x.wasteExchangeId,
      containerNumber: x.usedContainer?.containerNumber ?? idx + 1
    })) ?? [];

    wasteExchanges.push(...containerExchangeItems);
  }

  if (wastesDetailsData.saleWastes && wastesDetailsData.saleWastes?.wastes?.length > 0) {
    const saleWastes = mapToRequestWastes(wastesDetailsData.saleWastes?.wastes, true) ?? [];
    const saleExchangeItem = {
      isContainer: false,
      wastes: saleWastes,
      usedContainerId: null,
      wasteExchangeId: wastesDetailsData.saleWastes?.wasteExchangeId
    };

    wasteExchanges.push(saleExchangeItem);
  }

  if (wastesDetailsData.transportWastes && wastesDetailsData.transportWastes?.wastes?.length > 0) {
    const transportWastes = mapToRequestWastes(wastesDetailsData.transportWastes?.wastes) ?? [];
    const transportExchangeItem = {
      isContainer: false,
      wastes: transportWastes,
      usedContainerId: null,
      wasteExchangeId: wastesDetailsData.transportWastes?.wasteExchangeId,
    };

    wasteExchanges.push(transportExchangeItem);
  }
  const services = mapToServices(wastesDetailsData.services);

  return {
    internalInvoiceNumber: wastesDetailsData.internalInvoiceNumber,
    receivedNoteNumber: wastesDetailsData.receivedNoteNumber,
    externalInvoiceNumber: wastesDetailsData.externalInvoiceNumber,
    deliveryNoteNumber: wastesDetailsData.deliveryNoteNumber,
    weighbridgeTicketNumber: wastesDetailsData.weighbridgeTicketNumber,
    isBdoIntegrated: wastesDetailsData.isBdoIntegrated,
    wasteExchanges: wasteExchanges,
    isContainerExchange: transactionType === TRANSACTION_TYPE.PURCHASE ? wastesDetailsData.isContainerExchange : false,
    isLoading: transactionType === TRANSACTION_TYPE.PURCHASE ? wastesDetailsData.isLoading : false,
    generateSaleKpoCards: transactionType === TRANSACTION_TYPE.SALE ? wastesDetailsData.generateKpoCards : undefined,
    isWasteTransport: transactionType === TRANSACTION_TYPE.TRANSPORT ? wastesDetailsData.isWasteTransport : undefined,
    services: services
  };
}

const mapToRequestWastes = (wastes, includeExtendedData = false) => wastes?.map((x) => ({
  wasteId: x.wasteId,
  wasteMass: x.wasteMass,
  code: x.wasteCode,
  bdoId: x.wasteCodeBdoId,
  extendedData: includeExtendedData ? mapToExtendedData(x) : null,
  wasteKindId: x.wasteKindId,
  wasteFormType: x.wasteFormType
}));

const mapToServices = (services) =>  services?.map(x => ({
  orderServiceId: x.orderServiceId,
  serviceId: x.serviceId,
  pricingType: x.pricingType
})) ?? [];

const mapToExtendedData = (waste) => ({
  deductions: waste.deductions,
  initWasteMass: waste.initWasteMass,
  revenueDocumentNumber: getValueIfDeductionsNonZeroOrNull(waste.revenueDocumentNumber, waste.deductions),
  revenueWasteMass: waste.revenueWasteMass,
  wasteDifferenceReasons: getValueIfDeductionsNonZeroOrNull(waste.wasteDifferenceReasons, waste.deductions),
  wasteDifferenceOtherReason: getValueIfDeductionsNonZeroOrNull(waste.wasteDifferenceOtherReason, waste.deductions)
});

const getValueIfDeductionsNonZeroOrNull = (value, deductions) => Number(deductions) !== 0 ? value : null;